export default __webpack_public_path__ + "static/media/reg_step1.52af140f.webp";